export default __webpack_public_path__ + "static/media/2.715f8498.png";